(function () {
  'use strict';
  var HF = (window.HF = window.HF || {});
  var routes = HF.routes || {};
  var strings = HF.strings || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---------- money ---------- */
  function group(fixed, thousands, decimal) {
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts.join(decimal) : parts[0];
  }
  HF.formatMoney = function (cents) {
    var n = Number(cents || 0) / 100;
    if (HF.eurStyle) return group(n.toFixed(2), '.', ',') + ' €';
    var format = HF.moneyFormat || '{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var s;
    switch (key) {
      case 'amount_no_decimals': s = group(n.toFixed(0), ',', '.'); break;
      case 'amount_with_comma_separator': s = group(n.toFixed(2), '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': s = group(n.toFixed(0), '.', ','); break;
      case 'amount_with_space_separator': s = group(n.toFixed(2), ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': s = group(n.toFixed(0), ' ', ','); break;
      case 'amount_with_apostrophe_separator': s = group(n.toFixed(2), "'", '.'); break;
      default: s = group(n.toFixed(2), ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, s);
  };

  /* ---------- toast ---------- */
  var toastTimer;
  HF.toast = function (html, opts) {
    opts = opts || {};
    var el = $('[data-hf-toast]');
    if (!el) return;
    el.innerHTML = html;
    el.classList.toggle('hf-toast--error', !!opts.error);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, opts.duration || 3800);
  };

  /* ---------- cart api ---------- */
  function parse(r) {
    return r.json().then(function (data) {
      if (!r.ok) { var e = new Error(data.description || data.message || strings.error || 'Error'); e.data = data; throw e; }
      return data;
    });
  }
  HF.cart = {
    get: function () { return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(parse); },
    add: function (items) { return fetch(routes.cartAdd + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items: items }) }).then(parse); },
    change: function (payload) { return fetch(routes.cartChange + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify(payload) }).then(parse); },
    update: function (payload) { return fetch(routes.cartUpdate + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify(payload) }).then(parse); },
    refresh: function () {
      return HF.cart.get().then(function (cart) { HF.updateCartUI(cart); document.dispatchEvent(new CustomEvent('hf:cart', { detail: cart })); return cart; });
    }
  };
  HF.updateCartUI = function (cart) {
    var first = $('[data-hf-cart-count]');
    var prev = first ? parseInt(first.textContent, 10) : cart.item_count;
    if (prev !== cart.item_count) { $$('[data-hf-cart-link]').forEach(function (l) { l.classList.remove('is-bump'); void l.offsetWidth; l.classList.add('is-bump'); }); }
    $$('[data-hf-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-hf-cart-count-mini]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-hf-n', cart.item_count); });
    $$('[data-hf-cart-total]').forEach(function (el) { el.textContent = HF.formatMoney(cart.total_price); });
    $$('[data-hf-cart-meta]').forEach(function (el) { el.hidden = cart.item_count === 0; });
  };
  function addedToast(title) {
    HF.toast('<span>' + (strings.added || 'Added') + (title ? ': ' + escapeHtml(title) : '') + '</span><a href="' + routes.cart + '">' + (strings.view || 'Cart') + ' →</a>');
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- quick add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hf-add]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-hf-add'), 10);
    var qty = parseInt(btn.getAttribute('data-qty') || '1', 10) || 1;
    if (!id) return;
    btn.classList.add('is-loading');
    HF.cart.add([{ id: id, quantity: qty }]).then(function () { return afterAdd(btn.getAttribute('data-hf-title')); }).catch(function (err) { HF.toast(escapeHtml(err.message || strings.error), { error: true }); })
      .then(function () { btn.classList.remove('is-loading'); });
  });

  /* ---------- steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hf-step]');
    if (!btn) return;
    var box = btn.closest('[data-hf-stepper]');
    var input = box && box.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var val = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-hf-step'), 10);
    val = Math.max(min, Math.min(max, isNaN(val) ? min : val));
    input.value = val;
    syncStepper(box);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  function syncStepper(box) {
    var input = box.querySelector('input');
    var min = parseInt(input.min || '1', 10);
    var dec = box.querySelector('[data-hf-step="-1"]');
    if (dec) dec.disabled = parseInt(input.value, 10) <= min;
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-hf-stepper] input')) syncStepper(e.target.closest('[data-hf-stepper]'));
  });

  /* ---------- product form ---------- */
  function initProduct(root) {
    if (root.dataset.hfInit) return;
    root.dataset.hfInit = '1';
    var dataEl = $('[data-hf-variants]', root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $('[data-hf-form]', root);
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInputs = $$('[data-hf-qty] input', root);
    var qtyInput = qtyInputs[0] || null;
    qtyInputs.forEach(function (inp) {
      inp.addEventListener('change', function () {
        qtyInputs.forEach(function (other) { if (other !== inp) { other.value = inp.value; syncStepper(other.closest('[data-hf-stepper]')); } });
      });
    });
    var priceEl = $('[data-hf-price]', root);
    var compareEl = $('[data-hf-compare]', root);
    var unitEl = $('[data-hf-unit]', root);
    var ctaBtns = $$('[data-hf-cta]', root);
    var state = {};

    function selectedOptions() {
      var opts = [];
      $$('[data-hf-option]', root).forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function currentVariant() {
      if (!variants.length) return null;
      if (variants.length === 1) return variants[0];
      var opts = selectedOptions();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function planRadio() { return form.querySelector('input[name="selling_plan"]:checked'); }
    function giftRadio() { return root.querySelector('[data-hf-gift]:checked'); }

    /* Koala quantity breaks: the app puts its tiers into <koala-deal data-hf-koala>. On add to cart Koala sends the
       chosen tier's quantity, so the tier drives the steppers (hidden via .is-koala) and the button shows the tier total. */
    var koalaSlot = $('[data-hf-koala]', root);
    function koalaTier() {
      var block = koalaSlot && koalaSlot.querySelector('.koala-deal');
      if (!block || block.classList.contains('koala--hidden')) return null;
      var input = block.querySelector('.koala-deal__tier__input:checked');
      if (!input) return null;
      var data = (window.ProfitKoala || {})[block.getAttribute('data-block-id')] || {};
      var offer = (data.offers || []).filter(function (o) { return input.classList.contains('koala-contract-' + o.id); })[0];
      var title = input.parentNode.querySelector('.koala-deal__tier__title');
      var qty = offer ? offer.minQuantity || (offer.variants || []).length : parseInt(title ? title.textContent : '', 10);
      return qty > 0 ? { qty: qty, discount: offer && offer.discount } : null;
    }
    // Price per item after the tier discount, as Koala's discount sets it in the cart: price × (1 - %) in floating point,
    // cut to the cent with toFixed(2). So a half cent goes either way: 7,50 € × 0,95 → 7,13 €, 6,50 € × 0,95 → 6,17 €
    function koalaEach(unit, d) {
      if (!d || !(d.value > 0)) return unit;
      if (d.type === 'amount') return Math.max(0, unit - Math.round(d.value * 100));
      if (d.type !== 'percentage') return unit;
      return Math.round(Number((unit / 100 * (1 - d.value / 100)).toFixed(2)) * 100);
    }
    // Koala's tier takes the percentage off the whole line (2 × 12,50 € → 23,75 €), the cart takes it per item (23,76 €)
    function koalaTierPrices(unit) {
      var block = koalaSlot.querySelector('.koala-deal');
      var data = (window.ProfitKoala || {})[block.getAttribute('data-block-id')] || {};
      (data.offers || []).forEach(function (o) {
        if (!o.discount || o.discount.type !== 'percentage' || !(o.minQuantity > 0)) return;
        var el = block.querySelector('.tier-' + o.id + ' .koala-deal__tier__price');
        var text = HF.formatMoney(koalaEach(unit, o.discount) * o.minQuantity);
        if (el && el.textContent !== text) el.textContent = text;
      });
    }
    // Koala formats with the store format ("€15,20"); the theme writes "15,20 €"
    function koalaEuroAfter() {
      var walker = document.createTreeWalker(koalaSlot, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue.indexOf('€') === -1) continue;
        var t = n.nodeValue.replace(/€\s?(\d[\d.,]*)/g, '$1\u00a0€');
        if (t !== n.nodeValue) n.nodeValue = t;
      }
    }

    // Longest text that fits: label and price, then the short label and price, then the short label alone
    // (the phone bar next to the stepper, 320 px screens). Measured, because the length depends on the language, quantity and price.
    function fitCta(btn) {
      var f = btn.hfFit;
      var l = btn.querySelector('[data-hf-cta-label]');
      var p = btn.querySelector('[data-hf-cta-price]');
      if (!f || !l) return;
      var tries = f.labels.map(function (t) { return [t, f.price]; });
      if (f.price) tries.push([f.labels[f.labels.length - 1], '']);
      for (var i = 0; i < tries.length; i++) {
        l.textContent = tries[i][0];
        if (p) { p.textContent = tries[i][1]; p.hidden = !tries[i][1]; }
        if (btn.scrollWidth <= btn.clientWidth) break;
      }
    }

    function render() {
      var v = currentVariant();
      var available = !!(v && v.available);
      // Sold out: no Koala tiers and no steppers, only the disabled button
      root.classList.toggle('is-soldout', !available);
      if (koalaSlot) koalaSlot.hidden = !available;
      var tier = available ? koalaTier() : null;
      root.classList.toggle('is-koala', !!tier);
      if (tier) {
        qtyInputs.forEach(function (inp) {
          if (String(inp.value) !== String(tier.qty)) { inp.value = tier.qty; syncStepper(inp.closest('[data-hf-stepper]')); }
        });
      }
      var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) || 1 : 1;
      var plan = planRadio();
      var gift = giftRadio();
      state.variant = v;
      if (idInput && v) idInput.value = v.id;
      var unit = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      if (plan && plan.value && v) {
        try { var prices = JSON.parse(plan.getAttribute('data-hf-plan-prices') || '{}'); if (prices[v.id] != null) { compare = v.price; unit = prices[v.id]; } } catch (err) {}
      }
      if (priceEl) { priceEl.textContent = HF.formatMoney(unit); priceEl.classList.toggle('is-sale', compare > unit); }
      if (compareEl) { compareEl.hidden = !(compare > unit); compareEl.textContent = compare > unit ? HF.formatMoney(compare) : ''; }
      if (unitEl && v && v.unit_price_measurement && v.unit_price) {
        unitEl.textContent = HF.formatMoney(v.unit_price) + ' / ' + (v.unit_price_measurement.reference_value !== 1 ? v.unit_price_measurement.reference_value : '') + v.unit_price_measurement.reference_unit;
      }
      var giftPrice = gift && gift.value ? parseInt(gift.getAttribute('data-price') || '0', 10) : 0;
      if (tier && v && !(plan && plan.value)) koalaTierPrices(v.price);
      var total = ((tier ? koalaEach(unit, tier.discount) : unit) + giftPrice) * qty;
      // The button names the quantity it adds ("Добави 2 бр. в количката"); the phone bar starts from the short form
      var short = strings.addNShort ? strings.addNShort.replace('%n', qty) : (strings.addToCart || 'Add');
      var label = plan && plan.value ? (strings.subscribe || strings.addToCart) : (strings.addN ? strings.addN.replace('%n', qty) : short);
      ctaBtns.forEach(function (btn) {
        btn.disabled = !available;
        btn.hfFit = available ? { labels: btn.hasAttribute('data-hf-short') ? [short] : plan && plan.value ? [label] : [label, short], price: ' · ' + HF.formatMoney(total) } : { labels: [strings.soldout || 'Sold out'], price: '' };
        fitCta(btn);
      });
      if (v && variants.length > 1 && window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
      $$('[data-hf-option] label', root).forEach(function (label) {
        var input = label.querySelector('input');
        if (!input) return;
        var idx = parseInt(label.closest('[data-hf-option]').getAttribute('data-hf-option'), 10);
        var opts = selectedOptions();
        opts[idx] = input.value;
        var any = variants.some(function (vv) { return vv.available && vv.options.every(function (o, k) { return opts[k] === null || opts[k] === o; }); });
        label.classList.toggle('is-unavailable', !any);
      });
    }
    root.addEventListener('change', render);
    render();
    var fitQueued = false;
    var refit = function () { if (!fitQueued) { fitQueued = true; window.requestAnimationFrame(function () { fitQueued = false; ctaBtns.forEach(fitCta); }); } };
    window.addEventListener('resize', refit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
    // Koala inserts and shows its block after load and re-renders prices on variant change
    if (koalaSlot && window.MutationObserver) {
      var koalaQueued = false;
      new MutationObserver(function () {
        if (koalaQueued) return;
        koalaQueued = true;
        setTimeout(function () {
          koalaQueued = false;
          if (HF.eurStyle) koalaEuroAfter();
          render();
        }, 0);
      }).observe(koalaSlot, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    }

    function submit(e) {
      e.preventDefault();
      var v = state.variant;
      if (!v || !v.available) return;
      var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) || 1 : 1;
      var item = { id: v.id, quantity: qty, properties: {} };
      var plan = planRadio();
      if (plan && plan.value) item.selling_plan = parseInt(plan.value, 10);
      var gift = giftRadio();
      var items = [item];
      $$('[data-hf-property]', form).forEach(function (input) {
        if (input.type === 'checkbox' && !input.checked) return;
        if (input.value) item.properties[input.getAttribute('data-hf-property')] = input.value;
      });
      if (gift && gift.value) {
        item.properties[gift.getAttribute('data-label') || 'Gift'] = gift.getAttribute('data-value') || 'yes';
        items.push({ id: parseInt(gift.value, 10), quantity: qty });
      }
      if (!Object.keys(item.properties).length) delete item.properties;
      var btns = ctaBtns.slice();
      btns.forEach(function (b) { b.classList.add('is-loading'); });
      HF.cart.add(items).then(function () { return afterAdd(root.getAttribute('data-hf-title')); }).catch(function (err) { HF.toast(escapeHtml(err.message || strings.error), { error: true }); })
        .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
    }
    form.addEventListener('submit', submit);
    $$('[data-hf-cta-proxy]', root).forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); submit(e); });
    });
    var sticky = $('[data-hf-sticky]', root), mainCta = $('.hf-cta', root);
    if (sticky) document.body.classList.add('has-sticky');
    /* Phone: the bar at the bottom shows once the button in the page has scrolled up out of view (hf-mobile.css).
       Checked on scroll, not with IntersectionObserver: a jump past the button (#reviews, a fast fling) never makes it intersect. */
    if (sticky && mainCta) {
      var stickyQueued = false;
      var syncSticky = function () { stickyQueued = false; sticky.classList.toggle('is-away', mainCta.getBoundingClientRect().bottom > 0); };
      var queueSticky = function () { if (!stickyQueued) { stickyQueued = true; window.requestAnimationFrame(syncSticky); } };
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky);
      syncSticky();
    }
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    if (root.dataset.hfInit) return;
    root.dataset.hfInit = '1';
    var slides = $$('[data-hf-slide]', root);
    var thumbs = $$('[data-hf-thumb]', root);
    var dots = $$('[data-hf-dot]', root);
    var index = 0;
    function go(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); var vid = s.querySelector('video'); if (vid && k !== index) vid.pause(); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === index); t.setAttribute('aria-current', k === index ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var main = $('[data-hf-gallery-main]', root);
    if (main) {
      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) go(dx < 0 ? index + 1 : index - 1);
      }, { passive: true });
    }
    go(0);
  }

  /* ---------- frequently bought together ---------- */
  function initFbt(root) {
    if (root.dataset.hfFbt) return;
    root.dataset.hfFbt = '1';
    var totalEl = $('[data-hf-fbt-total]', root);
    var compareEl = $('[data-hf-fbt-compare]', root);
    var countEl = $('[data-hf-fbt-count]', root);
    var labelEl = $('[data-hf-fbt-label]', root);
    var labelMany = labelEl && labelEl.textContent;
    var btn = $('[data-hf-fbt-add]', root);
    var btnPrice = btn && btn.querySelector('[data-hf-fbt-btn-price]');
    function calc() {
      var total = 0, compare = 0, count = 0;
      $$('[data-hf-fbt-item]', root).forEach(function (cb) {
        cb.closest('.hf-fbt__item').classList.toggle('is-off', !cb.checked);
        if (!cb.checked) return;
        count++;
        total += parseInt(cb.getAttribute('data-price'), 10) || 0;
        compare += parseInt(cb.getAttribute('data-compare') || cb.getAttribute('data-price'), 10) || 0;
      });
      if (totalEl) totalEl.textContent = HF.formatMoney(total);
      if (compareEl) { compareEl.textContent = compare > total ? HF.formatMoney(compare) : ''; compareEl.hidden = !(compare > total); }
      if (countEl) countEl.textContent = count;
      if (labelEl) labelEl.textContent = count === 1 ? labelEl.getAttribute('data-one') : labelMany;
      if (btnPrice) btnPrice.textContent = ' · ' + HF.formatMoney(total);
      if (btn) btn.disabled = count === 0;
    }
    root.addEventListener('change', calc);
    calc();
    if (btn) btn.addEventListener('click', function () {
      var items = $$('[data-hf-fbt-item]:checked', root).map(function (cb) { return { id: parseInt(cb.value, 10), quantity: 1 }; });
      if (!items.length) return;
      btn.classList.add('is-loading');
      HF.cart.add(items).then(function () { return afterAdd(); })
        .catch(function (err) { HF.toast(escapeHtml(err.message || strings.error), { error: true }); })
        .then(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- recommendations (section rendering) ---------- */
  function initRecs(root) {
    if (root.dataset.hfRecs) return;
    root.dataset.hfRecs = '1';
    var url = root.getAttribute('data-url');
    if (!url) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-hf-recs-content]');
        var target = $('[data-hf-recs-content]', root);
        // Some products are listed twice under the same name, so keep one of each and never the product itself
        if (content) {
          var seen = {}, kept = 0, max = parseInt(root.getAttribute('data-hf-recs-max'), 10) || 99;
          seen[root.getAttribute('data-hf-recs-skip')] = true;
          $$('[data-hf-recs-key]', content).forEach(function (el) {
            var key = el.getAttribute('data-hf-recs-key');
            if (seen[key] || kept >= max) { el.remove(); return; }
            seen[key] = true;
            kept++;
          });
        }
        if (content && content.innerHTML.trim().length && target) {
          target.innerHTML = content.innerHTML;
          target.classList.add('hf-rise');
          root.removeAttribute('data-hf-empty');
          var wrap = root.closest('[data-hf-empty]');
          if (wrap) wrap.removeAttribute('data-hf-empty');
          if (root.hidden) (wrap || root).classList.add('hf-rise');
          root.hidden = false;
          initAll(root);
          root.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          var fb = root.getAttribute('data-url-fallback');
          if (fb && !root.dataset.hfFallback) { root.dataset.hfFallback = '1'; url = fb; load(); return; }
          root.setAttribute('data-hf-empty', '');
          root.hidden = true;
        }
      }).catch(function () { root.setAttribute('data-hf-empty', ''); root.hidden = true; });
    };
    // A root that starts hidden never intersects, so it loads right away
    if (!root.hidden && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(root);
    } else load();
  }

  /* ---------- cart page ---------- */
  function initCartPage(root) {
    if (root.dataset.hfInit) return;
    root.dataset.hfInit = '1';
    var sectionId = root.getAttribute('data-section-id');
    var busy = false;
    var sticky = $('[data-hf-cart-sticky]', root);
    // the form, not its button: co.middleware.bg hides the button (display:none) and adds its own next to it
    var mainCheckout = $('.hf-summary #hf-cart-form', root);
    document.body.classList.toggle('has-sticky', !!sticky);
    if (sticky && mainCheckout && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (en) { sticky.classList.toggle('is-away', en[0].isIntersecting); }, { threshold: 0.4 });
      sio.observe(mainCheckout);
    }
    function rerender(cart) {
      if (cart) HF.updateCartUI(cart);
      return fetch(routes.cart + '?section_id=' + sectionId).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-hf-cart-page]');
        if (fresh) {
          root.replaceWith(fresh);
          initCartPage(fresh);
        }
      });
    }
    function change(line, qty, lineEl) {
      if (busy) return;
      busy = true;
      if (lineEl) lineEl.classList.add('is-busy');
      HF.cart.change({ line: line, quantity: qty }).then(function (cart) {
        document.dispatchEvent(new CustomEvent('hf:cart', { detail: cart, cancelable: true }));
        return rerender(cart);
      }).catch(function (err) { HF.toast(escapeHtml(err.message || strings.error), { error: true }); if (lineEl) lineEl.classList.remove('is-busy'); })
        .then(function () { busy = false; });
    }
    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('[data-hf-line] [data-hf-stepper] input')) return;
      var lineEl = input.closest('[data-hf-line]');
      change(parseInt(lineEl.getAttribute('data-hf-line'), 10), parseInt(input.value, 10) || 0, lineEl);
    });
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-hf-line-remove]');
      if (rm) { e.preventDefault(); var lineEl = rm.closest('[data-hf-line]'); change(parseInt(lineEl.getAttribute('data-hf-line'), 10), 0, lineEl); }
    });
    var promo = $('[data-hf-promo]', root);
    if (promo) promo.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (promo.querySelector('input').value || '').trim();
      if (!code) return;
      window.location.href = routes.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routes.cart);
    });
    var note = $('[data-hf-cart-note]', root);
    if (note) note.addEventListener('change', function () { HF.cart.update({ note: note.value }); });
  }
  document.addEventListener('hf:cart', function (e) {
    var page = $('[data-hf-cart-page]');
    if (!page || page.dataset.hfRerendering) return;
    if (e.cancelable) return;
    page.dataset.hfRerendering = '1';
    fetch(routes.cart + '?section_id=' + page.getAttribute('data-section-id')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-hf-cart-page]');
      if (fresh) { page.replaceWith(fresh); initCartPage(fresh); }
    });
  });

  /* ---------- heat filter (client side) ---------- */
  function initHeatFilter(root) {
    if (root.dataset.hfInit) return;
    root.dataset.hfInit = '1';
    var gridSel = root.getAttribute('data-hf-heatfilter');
    var grid = gridSel ? $(gridSel) : root.parentElement;
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-heat]');
      if (!btn) return;
      var key = btn.getAttribute('data-heat');
      $$('[data-heat]', root).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); b.classList.toggle('hf-pill--active', b === btn); });
      if (!grid) return;
      $$('.hf-card', grid).forEach(function (card) {
        card.classList.toggle('is-hidden', key !== 'all' && card.getAttribute('data-heat') !== key);
      });
      var empty = $('[data-hf-heat-empty]', grid.parentElement);
      if (empty) empty.hidden = $$('.hf-card:not(.is-hidden)', grid).length > 0;
    });
  }

  /* ---------- filter panel toggle (filters, sort and paging: hf-collection.js) ---------- */
  document.addEventListener('click', function (e) {
    var ft = e.target.closest('[data-hf-filters-toggle]');
    if (ft) {
      var aside = $('#hf-filters');
      if (aside) { var open = aside.classList.toggle('is-open'); ft.setAttribute('aria-expanded', open ? 'true' : 'false'); document.body.classList.toggle('hf-filters-open', open); }
    }
    if (e.target.closest('[data-hf-filters-close]')) closeFilters();
    var cl = e.target.closest('[data-hf-cart-link]');
    if (cl && getDrawer()) { e.preventDefault(); HF.openCart(); }
  });
  function closeFilters() {
    var aside = $('#hf-filters');
    if (!aside || !aside.classList.contains('is-open')) return;
    aside.classList.remove('is-open');
    document.body.classList.remove('hf-filters-open');
    var tg = $('[data-hf-filters-toggle]'); if (tg) tg.setAttribute('aria-expanded', 'false');
  }

  /* ---------- drawer & search ---------- */
  function openDrawer() { var d = $('[data-hf-drawer]'); if (!d) return; d.hidden = false; document.body.classList.add('hf-drawer-open'); var c = d.querySelector('[data-hf-drawer-close]'); if (c) c.focus(); }
  function closeDrawer() { var d = $('[data-hf-drawer]'); if (!d) return; d.hidden = true; document.body.classList.remove('hf-drawer-open'); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hf-drawer-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-hf-drawer-close]')) { e.preventDefault(); closeDrawer(); }
    var st = e.target.closest('[data-hf-search-toggle]');
    if (st) {
      e.preventDefault();
      var panel = $('[data-hf-search-panel]');
      if (panel) { panel.hidden = !panel.hidden; if (!panel.hidden) { var inp = panel.querySelector('input'); if (inp) inp.focus(); } }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeCart(); closeFilters(); } });

  /* ---------- favorites ---------- */
  function favs() { try { return JSON.parse(localStorage.getItem('hf_favs') || '[]'); } catch (e) { return []; } }
  function initFav(btn) {
    var h = btn.getAttribute('data-hf-fav');
    btn.classList.toggle('is-active', favs().indexOf(h) > -1);
    btn.addEventListener('click', function () {
      var list = favs(); var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      try { localStorage.setItem('hf_favs', JSON.stringify(list)); } catch (e) {}
      btn.classList.toggle('is-active', i === -1);
    });
  }

  /* ---------- gift message bridge ---------- */
  function initGiftMessage(area) {
    if (area.dataset.hfInit) return;
    area.dataset.hfInit = '1';
    var counter = $('[data-hf-gift-counter]');
    var max = parseInt(area.maxLength || '120', 10);
    function sync() {
      var target = $('[data-hf-gift-message-target]');
      if (target) target.value = area.value;
      if (counter) counter.textContent = area.value.length + ' / ' + max;
    }
    area.addEventListener('input', sync);
    sync();
    var direct = $('[data-hf-gift-direct]');
    if (direct) direct.addEventListener('change', function () { var t = $('[data-hf-gift-direct-target]'); if (t) t.value = direct.checked ? direct.value : ''; });
  }

  /* ---------- cart drawer ---------- */
  var cartDrawer = null, cartCloseTimer;
  function getDrawer() { if (!cartDrawer) cartDrawer = $('[data-hf-cart-drawer]'); return cartDrawer; }
  function openCart() {
    var d = getDrawer(); if (!d) return false;
    clearTimeout(cartCloseTimer);
    d.hidden = false;
    document.body.classList.add('hf-cart-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    var panel = d.querySelector('.hf-cdrawer__panel'); if (panel) panel.focus({ preventScroll: true });
    return true;
  }
  function closeCart() {
    var d = getDrawer(); if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.classList.remove('hf-cart-open');
    cartCloseTimer = setTimeout(function () { d.hidden = true; }, 300);
  }
  function renderCartDrawer() {
    var d = getDrawer(); if (!d) return Promise.resolve();
    return fetch(routes.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json['cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-hf-cart-drawer-content]');
        var cur = $('[data-hf-cart-drawer-content]', d);
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; initAll(cur); }
      }).catch(function () {});
  }
  HF.openCart = function () { renderCartDrawer(); return openCart(); };
  HF.closeCart = closeCart;
  function afterAdd(title) {
    return HF.cart.refresh().then(function () {
      return renderCartDrawer().then(function () { if (!openCart()) addedToast(title); });
    });
  }
  function initCartDrawer(root) {
    if (root.dataset.hfInit) return;
    root.dataset.hfInit = '1';
    var busy = false;
    function change(line, qty, lineEl) {
      if (busy) return;
      busy = true;
      if (lineEl) lineEl.classList.add('is-busy');
      HF.cart.change({ line: line, quantity: qty }).then(function (cart) {
        HF.updateCartUI(cart);
        document.dispatchEvent(new CustomEvent('hf:cart', { detail: cart }));
        return renderCartDrawer();
      }).catch(function (err) { HF.toast(escapeHtml(err.message || strings.error), { error: true }); if (lineEl) lineEl.classList.remove('is-busy'); })
        .then(function () { busy = false; });
    }
    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('[data-hf-line] [data-hf-stepper] input')) return;
      var lineEl = input.closest('[data-hf-line]');
      change(parseInt(lineEl.getAttribute('data-hf-line'), 10), parseInt(input.value, 10) || 0, lineEl);
    });
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-hf-line-remove]');
      if (rm) { e.preventDefault(); var lineEl = rm.closest('[data-hf-line]'); change(parseInt(lineEl.getAttribute('data-hf-line'), 10), 0, lineEl); return; }
      if (e.target.closest('[data-hf-cart-close]')) { e.preventDefault(); closeCart(); }
    });
  }

  /* ---------- mobile header: hide on scroll down, show on scroll up ---------- */
  (function () {
    var header = $('[data-hf-header]'); if (!header) return;
    var row = header.querySelector('.hf-header__row');
    var mq = window.matchMedia('(max-width: 1023px)');
    var lastY = window.scrollY, ticking = false, rowTop = 0;
    function measure() {
      if (!row) return;
      var wasStuck = header.classList.contains('is-stuck');
      header.classList.remove('is-stuck');
      header.style.setProperty('--hf-row-h', row.offsetHeight + 'px');
      rowTop = row.getBoundingClientRect().top + window.scrollY;
      if (wasStuck) header.classList.add('is-stuck');
    }
    function update() {
      ticking = false;
      if (!mq.matches) { header.classList.remove('is-hidden'); header.classList.remove('is-stuck'); lastY = window.scrollY; return; }
      var y = window.scrollY, delta = y - lastY;
      header.classList.toggle('is-stuck', y > rowTop - 8);
      if (document.body.classList.contains('hf-drawer-open') || document.body.classList.contains('hf-cart-open') || document.body.classList.contains('hf-filters-open')) { lastY = y; return; }
      if (y < rowTop + 80) header.classList.remove('is-hidden');
      else if (delta > 8) header.classList.add('is-hidden');
      else if (delta < -8) header.classList.remove('is-hidden');
      lastY = y;
    }
    measure();
    update();
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', function () { measure(); update(); });
    window.addEventListener('load', function () { measure(); update(); });
  })();

  /* ---------- reveal on scroll ---------- */
  var revealIO = null;
  var revealSel = '.hf-shell .shopify-section > *:not(.hf-hero):not(.hf-product):not(.hf-coll-body):not([data-hf-empty]):not([hidden]), .hf-product .hf-strip, .hf-product .hf-buybox';
  var staggerSel = '.hf-grid, .hf-occ, .hf-why__grid, .hf-recipes__grid, .hf-timeline, .hf-about-grid, .hf-inside__grid, .hf-bundle__cards, .hf-supp-list, .hf-hero__mini, .hf-chips, .hf-upsell__grid';
  function initReveal(scope) {
    if (!document.documentElement.classList.contains('hf-js')) return;
    var reduce = !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vh = window.innerHeight;
    var targets = $$(staggerSel, scope).map(function (el) { return { el: el, attr: 'data-hf-stagger' }; })
      .concat($$(revealSel, scope).filter(function (el) { return !el.matches(staggerSel); }).map(function (el) { return { el: el, attr: 'data-hf-reveal' }; }));
    if (!revealIO && !reduce) revealIO = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-inview'); revealIO.unobserve(en.target); } }); }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    targets.forEach(function (t) {
      var el = t.el;
      if (el.hasAttribute('data-hf-reveal') || el.hasAttribute('data-hf-stagger')) return;
      if (t.attr === 'data-hf-stagger') Array.prototype.forEach.call(el.children, function (c, i) { c.style.setProperty('--hf-i', Math.min(i, 9)); });
      var top = el.getBoundingClientRect().top;
      el.setAttribute(t.attr, '');
      if (reduce || top < vh * 0.9) { el.classList.add('is-inview'); return; }
      revealIO.observe(el);
    });
  }

  /* ---------- third-party chat bubble: lift above the sticky bar, hide under overlays ---------- */
  var chatObserved = false;
  function syncChatHidden() {
    var host = document.getElementById('zipchat-shadow-host'); if (!host) return;
    var b = document.body.classList;
    if (b.contains('hf-cart-open') || b.contains('hf-drawer-open') || b.contains('hf-filters-open')) host.setAttribute('data-hf-hide', '');
    else host.removeAttribute('data-hf-hide');
  }
  function liftChat(tries) {
    var host = document.getElementById('zipchat-shadow-host');
    if (!host || !host.shadowRoot) { if (tries > 0) setTimeout(function () { liftChat(tries - 1); }, 1000); return; }
    if (!chatObserved) { chatObserved = true; new MutationObserver(syncChatHidden).observe(document.body, { attributes: true, attributeFilter: ['class'] }); }
    syncChatHidden();
    if (!host.shadowRoot.getElementById('hf-chat-hide')) {
      var hs = document.createElement('style'); hs.id = 'hf-chat-hide';
      hs.textContent = ':host([data-hf-hide]) #widget-chat-container{display:none !important;visibility:hidden !important;opacity:0 !important;pointer-events:none !important}';
      host.shadowRoot.appendChild(hs);
    }
    if (!window.matchMedia('(max-width: 767px)').matches || !document.body.classList.contains('has-sticky')) return;
    if (host.shadowRoot.getElementById('hf-chat-lift')) return;
    var st = document.createElement('style'); st.id = 'hf-chat-lift';
    st.textContent = '#widget-chat-container{bottom:calc(92px + env(safe-area-inset-bottom)) !important}';
    host.shadowRoot.appendChild(st);
  }

  /* ---------- init ---------- */
  function initAll(scope) {
    scope = scope || document;
    $$('[data-hf-cart-drawer]', scope).forEach(initCartDrawer);
    $$('[data-hf-product]', scope).forEach(initProduct);
    $$('[data-hf-gallery]', scope).forEach(initGallery);
    $$('[data-hf-fbt]', scope).forEach(initFbt);
    $$('[data-hf-recs]', scope).forEach(initRecs);
    $$('[data-hf-cart-page]', scope).forEach(initCartPage);
    $$('[data-hf-heatfilter]', scope).forEach(initHeatFilter);
    $$('[data-hf-stepper]', scope).forEach(syncStepper);
    $$('[data-hf-fav]', scope).forEach(function (b) { if (!b.dataset.hfInit) { b.dataset.hfInit = '1'; initFav(b); } });
    $$('[data-hf-gift-message]', scope).forEach(initGiftMessage);
    $$('[data-hf-cart-count-mini]', scope).forEach(function (el) { el.setAttribute('data-hf-n', el.textContent.trim()); });
    initReveal(scope);
    liftChat(10);
  }
  HF.init = initAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
